import * as React from 'react'
import './index.scss'
import {connect} from "react-redux";
import {ActionType} from "../../reducers/types";
import {Dispatch} from "redux";
import FormControl from "@material-ui/core/FormControl";
import {SALT_STRING} from "../../constants";
import FormHelperText from "@material-ui/core/FormHelperText";
import {MyInput, Label, PrimaryButton, WhiteButton} from "../../components/CustomUIComp/CustomFormElem";
import md5 from "js-md5";
import {injectIntl, IntlShape} from 'react-intl'

interface IProps {
    dispatch: Dispatch<ActionType<any>>,
    handleClose: () => void,
    intl: IntlShape
}
interface IState {
    password: string,
    errors: { [key: string]: string }
}

class PasswordModal extends React.Component<IProps, IState> {
    constructor(props: IProps){
        super(props)
        this.state = {
            password: '',
            errors: {}
        }
    }

    handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        let newState = {
            ...this.state,
            [event.target.name]: event.target.value
        }
        this.setState(newState)
    }
    check = () => {
        let {intl} = this.props
        let errors :{[key: string]: string} = {}

        if(!this.state.password){
            errors['password'] = intl.formatMessage({id: 'passwrodNotNull'})
        }

        this.setState({errors: errors})
        if(Object.keys(errors).length === 0){
            return true
        }else {
            return false
        }
    }
    onConfirm = () => {
        if(this.check()){
            this.props.dispatch({type: 'GET_SIGN_KEY', payload: {password: md5(this.state.password + SALT_STRING)}})
        }
    }

    public render() {
        let errors = this.state.errors
        let {intl} = this.props
        return <div className="passwordModal">
            <div className="LoginForm">
                <FormControl className="formControl" fullWidth required error={errors['password'] ? true : false}>
                    <Label shrink htmlFor="newPassword">
                        {intl.formatMessage({id: 'password'})}
                    </Label>
                    <MyInput type="password"
                            value={this.state.password}
                            onChange={this.handleInputChange}
                            name="password"/>
                    {errors['password'] ?
                        <FormHelperText id="password-error-text">{errors['password']}</FormHelperText> : null}
                </FormControl>
            </div>
            <div className="button-line">
                <WhiteButton onClick={this.props.handleClose}>
                    {intl.formatMessage({id: 'cancel'})}
                </WhiteButton>
                <PrimaryButton onClick={this.onConfirm}>
                    {intl.formatMessage({id: 'confirm'})}
                </PrimaryButton>
            </div>
        </div>;
    }
}

export default injectIntl(connect()(PasswordModal))
